<script>
import { Line } from 'vue-chartjs';
import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips';
import { getStyle } from '@coreui/coreui-pro/dist/js/coreui-utilities';
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';

export default {
  extends: Line,
  props: ['height', 'width'],
  async mounted() {
    const recent = await this.fetchDistributorRecentlyCompleted();

    const obj = Object.assign([], recent);
    // console.log('recent', recent);

    const days = [...Array(15).keys()];
    const numberGenerated = [];
    const dateLabel = [];
    days.shift();
    days.reverse();
    const verboseDays = [];
    // const verboseDays = [];
    for (const i in days) {
      verboseDays.push(
        moment()
          .subtract(days[i], 'd')
          .format('dddd, [the] Do [of] MMM')
      );
      const dateToCheck = moment()
        .subtract(days[i], 'd')
        .format('M-D-YYYY');
      let c = 0;
      for (const inc in obj) {
        if (dateToCheck === obj[inc].completion_date) {
          c++;
        }
      }
      dateLabel[i] = dateToCheck;
      numberGenerated[i] = c;
    }

    // console.log(dateLabel);
    // console.log(numberGenerated);

    const brandInfo = getStyle('--light-blue') || '#63c2de';
    const datasets2 = [
      {
        label: 'Reports',
        backgroundColor: brandInfo,
        borderColor: 'rgba(255,255,255,.55)',
        data: numberGenerated
      }
    ];

    this.renderChart(
      {
        labels: dateLabel,
        datasets: datasets2
      },
      {
        tooltips: {
          enabled: false,
          custom: CustomTooltips
        },
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        scales: {
          xAxes: [
            {
              gridLines: {
                color: 'transparent',
                zeroLineColor: 'transparent'
              },
              ticks: {
                fontSize: 2,
                fontColor: 'transparent'
              }
            }
          ],
          yAxes: [
            {
              display: false,
              ticks: {
                display: false,
                min: Math.min.apply(Math, datasets2[0].data) - 5,
                max: Math.max.apply(Math, datasets2[0].data) + 5
              }
            }
          ]
        },
        elements: {
          line: {
            tension: 0.00001,
            borderWidth: 1
          },
          point: {
            radius: 4,
            hitRadius: 10,
            hoverRadius: 4
          }
        }
      }
    );
  },
  computed: {
    ...mapGetters('dashboard', [
      'getTestTakersOnline',
      'getDistributorRecentlyCompleted'
    ])
  },
  methods: {
    ...mapActions('dashboard', [
      'fetchActiveUsers',
      'fetchDistributorRecentlyCompleted'
    ])
  }
};
</script>
